export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-DomesticTicketAirportSelector',
            name: 'admin-yinzhilv-demo-DomesticTicketAirportSelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-DomesticTicketAirportSelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-DomesticTicketAirportSelector`},
                ],
                skip_check_token: true,
            },
        },
    ],
};
